import {
  formatDate
} from '@/components/common/js/date.js';
const vFilters = {
  filterSource(type) {
    if (type == 0) {
      return type = '实体店';
    } else if (type == 1) {
      return type = '实体店';
    } else if (type == 2) {
      return type = '小程序';
    } else if (type == 3) {
      return type = 'APP'
    }
  },
  filterShape(type) {
    if (type == 2) {
      return type = '偏瘦';
    } else if (type == 3) {
      return type = '适中';
    } else if (type == 4) {
      return type = '微胖';
    } else if (type == 5) {
      return type = '轻度肥胖'
    } else if (type == 6) {
      return type = '重度肥胖'
    }
  },
  filterProcreate(type) {
    if (type == 1) {
      return type = '妊娠';
    } else if (type == 2) {
      return type = '产后';
    } else if (type == 3) {
      return type = '孕前'
    }
  },
  filterDevelop(type){
    if (type == 1) {
      return type = '下';
    } else if (type == 2) {
      return type = '中下';
    } else if (type == 3) {
      return type = '中';
    } else if (type == 4) {
      return type = '中上'
    } else if (type == 5) {
      return type = '上'
    }
  },
  filterOrgan(val, data) {
    if (val && val != '') {
      let myVal = [];
      for (let i of data) {
        if (val.indexOf(i.id) != -1) {
          myVal.push(i.name);
        }
      }
      return val = myVal.join(',');
    } else {
      return '--'
    }
  },
  filterLevel(type){
    if (type == 1) {
      return type = '初级调理师';
    }
  },
  filterDueStyle(type){
    if (type == 1) {
      return type = '顺产';
    } else if (type == 2) {
      return type = '剖宫产';
    }
  },
  filterRow(val) {
    if (!val || val == '') {
      return val = '--'
    } else {
      return val;
    }
  },
  filterTime(val) {
    if (val && val != '') {
      return formatDate(val, 'MM-dd HH:mm:ss');
    }
  },
  filterNoHouerTime(val) {
    if (val && val != '') {
      return formatDate(val, 'HH:mm');
    }
  },
  formatDate(val) {
    if (val && val != '') {
      return formatDate(val, 'yyyy.MM.dd HH:mm');
    }
  },
  formatDateNoHouer(val){
    if (val && val != '') {
      return formatDate(val, 'yyyy-MM-dd');
    }
  },
  formatDateLine(val){
    if (val && val != '') {
      return formatDate(val, 'yyyy-MM-dd HH:mm');
    }
  },
  formatDateLiness(val){
    if (val && val != '') {
      return formatDate(val, 'yyyy-MM-dd HH:mm:ss');
    }
  },
  formatDatenoH(val){
    if (val && val != '') {
      let date = new Date(val.split('-').length > 1 ? val : parseInt(val));
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = date.getDate();
      return Y + M + D;
    }
  },
  formatDateYear(val) {
    if (val && val != '') {
      let date = new Date(val.split('-').length > 1 ? val : parseInt(val));
      let Y = date.getFullYear() + '年';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
      let D = date.getDate() + '日';
      return Y + M + D;
    }
  },
  formatDateMon(val) {
    if (val && val != '') {
      let date = new Date(val.split('-').length > 1 ? val : parseInt(val));
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
      let D = (date.getDate() < 10 ?'0'+date.getDate() : date.getDate()) + '日';
      return M + D;
    }
  },
  filterPostId(val, data) {
    if (val && val != '') {
      for (let i of data) {
        if (i.id == val) {
          return i.name;
        }
      }
    }
  },
  filterStatus(type) {
    if (type == 1) {
      return type = '在职';
    } else if (type == 2) {
      return type = '暂停使用'
    } else if (type == 3) {
      return type = '离职'
    }
  },
  filterFlag(type) {
    if (type == 1) {
      return type = '未处理';
    } else if (type == 2) {
      return type = '已处理'
    } else {
      return '--'
    }
  },
  filterAddType(type) {
    if (type == 1) {
      return type = '单次';
    } else if (type == 2) {
      return type = '整套'
    } else if (type == 3) {
      return type = '组合套餐';
    } else if (type == 4) {
      return type = '体验卡服务';
    } else if (type == 5) {
      return type = '上门服务';
    } else if (type == 6) {
      return type = '限次卡';
    } else if (type == 7) {
      return type = '限时卡';
    } else if (type == 8) {
      return type = '限时限次卡';
    }else if (type == 19) {
      return type = '零售商品';
    } else if (type == 20) {
      return type = '体验商品';
    }
  },
  filterAudStatus(type) {
    if (type == 0) {
      return type = '未编辑';
    } else if (type == 1) {
      return type = '未提交审核';
    } else if (type == 2) {
      return type = '已提交未审核'
    } else if (type == 3) {
      return type = '审核通过';
    } else if (type == 4) {
      return type = '审核驳回';
    }
  },
  filterforSale(type) {
    if (type == 1) {
      return type = '已上架';
    } else if (type == 0) {
      return type = '未上架'
    }
  },
  filterSaleChannel(type) {
    let saleJson = [];
    if (type && type.length > 0) {
      for (let i of type) {
        if (i == 1) {
          saleJson.push('APP')
        } else if (i == 2) {
          saleJson.push('小程序')
        }
      }
    }
    return type = saleJson.join('，')
  },
  filterAtatus(type){
    if (type == 1) {
      return type = '未接单';
    } else if (type == 2) {
      return type = '待服务'
    } else if (type == 3) {
      return type = '服务中';
    } else if (type == 4) {
      return type = '已结束';
    } else if (type == 5) {
      return type = '已取消';
    }
  },
  filterScorce(type){
    if (type == 1) {
      return type = '零售销售';
    } else if (type == 2) {
      return type = '服务销售'
    } else if (type == 3) {
      return type = '服务消耗';
    } else if (type == 4) {
      return type = '充值';
    } else if (type == 5) {
      return type = '手工费';
    }
  },
  filterTyTime(type){
    if (type == 0) {
      return type = '3天';
    } else if (type == 1) {
      return type = '5天'
    } else if (type == 2) {
      return type = '7天';
    } else if (type == 3) {
      return type = '10天';
    } else if (type == 4) {
      return type = '15天';
    }else if (type == 5) {
      return type = '30天';
    }else if (type == 6) {
      return type = '2个月';
    }else if (type == 7) {
      return type = '3个月';
    }else if (type == 8) {
      return type = '4个月';
    }else if (type == 9) {
      return type = '5个月';
    }else if (type == 10) {
      return type = '半年';
    }else if (type == 11) {
      return type = '一年';
    }
  }
}

export default vFilters;



// WEBPACK FOOTER //
// ./src/assets/js/filter.js